import { clearChat, MESSAGES } from "../api/message-request";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

type UseClearChatParams = {
  senderId: number;
  receiverId: number;
};

const clear = async (senderId: number, receiverId: number) => {
  const response = await clearChat(senderId, receiverId);
  return response.data;
};

export const useClearChat = ({ senderId, receiverId }: UseClearChatParams) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => clear(senderId, receiverId),
    onSuccess: () => {
      toast.success("Chat cleared Successfully!");
      queryClient.invalidateQueries({
        queryKey: [MESSAGES, senderId, receiverId],
      });
    },
    onError: () => {
      console.error("Clear chat failed!");
    },
  });
};
